import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Typography, Divider, Popper, Paper, Box } from '@mui/material';

const CustomPopper = ({
  open,
  anchorEl,
  placement,
  popperClassName,
  paperClassName,
  title,
  divider,
  content,
  onClosePopper,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={placement ? placement : 'bottom'}
      className={popperClassName ? popperClassName : ''}>
      <Paper className={paperClassName ? paperClassName : ''}>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <Typography style={{ fontWeight: 'bold' }}>{title}</Typography>
          <CloseIcon
            onClick={onClosePopper}
            style={{ width: '20px', cursor: 'pointer' }}
          />
        </Box>
        {divider && <Divider className={divider} />}
        {content}
      </Paper>
    </Popper>
  );
};

export default CustomPopper;
